import { useAuth } from "@/src/provider/AuthProvider";
import { Navigate, Outlet, generatePath, useNavigate } from "react-router-dom";
import { Paths } from "../constants/Paths";

export const ProtectedRoute = () => {
  let returnUrl = "returnUrl=" + window.location.pathname;
  const { token } = useAuth();
  // Check if the user is authenticated
  if (!token) {
    // If not authenticated, redirect to the login page
    const path = Paths.ROUTE_LOGIN + "?" + returnUrl;
    return <Navigate to={path} />;
  }

  // If authenticated, render the child routes
  else return <Outlet />;
};
